module.exports = __webpack_public_path__ + "static/media/[折磨]@2x.05b4f464.png";